import { asMultiStyleConfig } from '../../../../utils/theme';
export var AttentionMessage = asMultiStyleConfig({
  parts: ['container'],
  baseStyle: {
    container: {
      py: 6
    }
  }
});